import { Route, Routes, } from 'react-router-dom';
import Projects from './components/Projects/Ranking/Ranking';
import axios from "axios"
import Landing from './components/Landing/Landing';
import { useState } from 'react';
import AllProjects from './components/Projects/allProjects/AllProjects';
import Testnet from './components/testnet/Testnet';

// axios.defaults.baseURL= "http://localhost:7049"
axios.defaults.baseURL= process.env.REACT_APP_BACKURL

export default function App(){
  const [colorFondo, setColorFondo] = useState("beige")

    return(
        <>
        <Routes>
            <Route path='/' element={<Landing colorFondo={colorFondo} setColorFondo= {setColorFondo}/>}/>
            <Route path='projects' element={<Projects colorFondo={colorFondo} setColorFondo= {setColorFondo}/>}/>
            <Route path='allProjects' element={<AllProjects colorFondo={colorFondo} setColorFondo= {setColorFondo}/>}/>
            <Route path='testnet' element={<Testnet colorFondo={colorFondo} setColorFondo= {setColorFondo}/>}/>
        </Routes>
        </>
    )
}